module.exports = ['$translate',
  function($translate) {
    // Ԥ�ȶ���$translate ����Ϊajax����JSON�ļ��첽���ض�������Դû�м���, �ʵ���Ϊ����ʵ�ַ�ʽ
    return function(folder) {
      let result

      const folderMap = {
        '1': {name: $translate.instant('MAIL.FOLDER.INBOX'), iconClass: 'iconfont icon-iconinbox email-folder-icon'},
        '2': {name: $translate.instant('MAIL.FOLDER.DRAFT'), iconClass: 'iconfont icon-iconfile email-folder-icon'},
        '3': {name: $translate.instant('MAIL.FOLDER.SENT'), iconClass: 'iconfont icon-iconfly email-folder-icon'},
        '4': {name: $translate.instant('MAIL.FOLDER.TRASH'), iconClass: 'iconfont icon-icondelete email-folder-icon'},
        '5': {name: $translate.instant('MAIL.FOLDER.SPAM'), iconClass: 'iconfont icon-iconrubbish email-folder-icon'},
        '6': {name: $translate.instant('MAIL.FOLDER.VIRUS'), iconClass: 'iconfont icon-iconvirus email-folder-icon'},
        '-1': {name: $translate.instant('MAIL.FOLDER.VIP'), iconClass: 'iconfont icon-iconimportant email-folder-icon'},
        '-3': {name: $translate.instant('MAIL.FOLDER.FLAGGED'), iconClass: 'iconfont icon-iconflag email-folder-icon'},
        '-5': {name: $translate.instant('MAIL.FOLDER.TODO'), iconClass: 'iconfont icon-iconwait email-folder-icon'},
        '-2': {name: $translate.instant('MAIL.FOLDER.UNREAD'), iconClass: 'iconfont icon-iconemail email-folder-icon'}
      }

      result = {
        name: folder ? (folder.name || '') : '',
        iconClass: 'iconfont icon-iconfolder email-folder-icon'
      }

      if (folder) {
        if (folder.id && folderMap[folder.id]) {
          // �����ļ���
          result = folderMap[folder.id]
        }

        if (folder.auth2Locked) {
          result.iconClass = 'iconfont icon-icon_File_Lock email-folder-icon'
        }
      }

      return result
    }
  }
]



// WEBPACK FOOTER //
// ./src/js/mail/folderNameFilter.js